import { useMutation, useQueryClient } from '@tanstack/react-query'
import { transferOwnershipService } from '@/services/agendas'

export const useTransferOwnership = (agendaId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (newOwnerUserId: string) => transferOwnershipService(agendaId, newOwnerUserId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['agendas', agendaId, 'members'] })
    },
  })
}
